export * from "@vaadin/icon/vaadin-icon.js";
export * from './generated/Icon.js';
